
import { Component, Vue } from "vue-property-decorator";
import { UserModule } from "@/store/modules/user";

@Component({
  name: "Redirect"
})
export default class extends Vue {
  created() {
    UserModule.Login().then(() => {
      location.reload();
    });
  }

  render() {
    // Avoid warning for missing template
  }
}
